import * as React from "react";
const SvgSteamTrap = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 50, height: 50, viewBox: "0 0 50.0 50.0", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 50, height: 50, fill: "none", stroke: "currentColor", strokeWidth: 1 }));
export default SvgSteamTrap;
